import React, { useState } from 'react';
import { Modal, Input } from 'antd';
import { HistoryColor } from 'services/store/enums/historyColor.enum';
import { IProject } from 'services/store/types/projects/Projects';

interface IProps {
  project: IProject;
  closeModal: () => void;
  handleUpdateProject: (
    updateData: Partial<IProject>,
    historyUpdate: string[],
    historyColor: HistoryColor
  ) => Promise<any>;
}

const ChangeProjectNameModal: React.FC<IProps> = ({
  project,
  closeModal,
  handleUpdateProject,
}) => {
  const [name, setName] = useState<string>(project.name);

  const onOk = async () => {
    const historyUpdate = [
      `Zaktualizowano nazwę projektu:`,
      `${project.name} na ${name}`,
    ];
    await handleUpdateProject({ name }, historyUpdate, HistoryColor.SUCCESS);
    closeModal();
  };

  return (
    <Modal
      title="Zmiana nazwy projektu"
      destroyOnClose
      visible
      onCancel={closeModal}
      maskClosable={false}
      onOk={onOk}
    >
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Nazwa zamówienia"
        style={{ width: '100%' }}
      />
    </Modal>
  );
};

export default ChangeProjectNameModal;
